import React, { Component } from 'react'
import styled from 'styled-components'
import { updateObject, updateDeepKey } from 'helpers/objectHelpers'
import FormInput from 'components/forms/bases/FormInput'
import FormSelect from 'components/forms/bases/FormSelect'
import Accordion from 'components/accordions/Accordion'
import Wrapper from 'components/wrappers/Wrapper'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import { refElements } from '../../../renderer/utils/elementUtils'
import TextContent from '../../elementForms/text/TextContent'
import ButtonContent from '../../elementForms/button/ButtonContent'
import ImageContent from '../../elementForms/image/ImageContent'
import DividerContent from '../../elementForms/divider/DividerContent'
import CardContent from '../../elementForms/card/CardContent'
import CategoryMenusContent from '../../elementForms/categoryMenus/CategoryMenusContent'
import ImageCarouselContent from '../../elementForms/imageCarousel/ImageCarouselContent'
import CountDownContent from '../../elementForms/countDown/CountDownContent'
import ColumnsContent from '../../elementForms/columns/ColumnsContent'
import ProductCardContent from '../../elementForms/productCard/ProductCardContent'
import ProductSliderContent from '../../elementForms/productSlider/ProductSliderContent'
import YoutubeContent from '../../elementForms/youtube/YoutubeContent'
import TextEditorContent from '../../elementForms/textEditor/TextEditorContent'

const DevicesImageContent = withDevicesForm(ImageContent)
const DevicesCardContent = withDevicesForm(CardContent)
const DevicesCategoryMenusContent = withDevicesForm(CategoryMenusContent)
const DevicesImageCarouselContent = withDevicesForm(ImageCarouselContent)
const DevicesColumnsContent = withDevicesForm(ColumnsContent)

const SimpleWrapper = styled.div`
  margin: 0 20px;
`

const ContentSwitcher = ({
  elementId,
  refElement,
  value,
  value: {
    defaultContent = {},
    deviceContent = {},
    defaultSettings = {},
    deviceSettings = {},
  },
  onChange,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  const handleDeepUpdate = (val, ...keys) => {
    return onChange(updateDeepKey(value, val, ...keys))
  }
  const renderForms = () => {
    switch (refElement) {
      case refElements.TEXT_EDITOR:
        return (
          <Wrapper margin={1}>
            <TextEditorContent
              elementId={elementId}
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      case refElements.PRODUCT_CARD:
        return (
          <Wrapper margin={1}>
            <ProductCardContent
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      case refElements.YOUTUBE:
        return (
          <Wrapper margin={1}>
            <YoutubeContent
              label="Default content"
              subValue="default"
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      case refElements.TEXT:
        return (
          <Wrapper margin={1}>
            <TextContent
              label="Default content"
              subValue="default"
              valueContent={defaultContent}
              onChangeContent={(val) => handleUpdate(val, 'defaultContent')}
              valueSettings={defaultSettings}
              onChangeSettings={(val) => handleUpdate(val, 'defaultSettings')}
            />
          </Wrapper>
        )
      case refElements.BUTTON:
        return (
          <Wrapper margin={1}>
            <ButtonContent
              label="Default Content"
              subValue="default"
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      case refElements.IMAGE:
        return (
          <div>
            <SimpleWrapper>
              <FormInput
                label="Caption"
                value={defaultContent.caption}
                onChange={(val) => handleDeepUpdate(val, 'defaultContent', 'caption')}
              />
              <FormSelect
                label="Caption Position"
                value={defaultContent.captionPosition}
                options={[
                  { label: 'Top Left', value: 'topLeft' },
                  { label: 'Top Right', value: 'topRight' },
                  { label: 'Center', value: 'center' },
                  { label: 'Bottom Left', value: 'bottomLeft' },
                  { label: 'Bottom Right', value: 'bottomRight' },
                ]}
                onChange={(val) => handleDeepUpdate(val, 'defaultContent', 'captionPosition')}
              />
            </SimpleWrapper>
            <Accordion defaultActiveItems={['default']}>
              <ImageContent
                label="Default Content"
                subValue="default"
                valueContent={defaultContent}
                onChangeContent={(val) => handleUpdate(val, 'defaultContent')}
              />
              <DevicesImageContent
                label="Override content in each device"
                subValue="device"
                valueContent={deviceContent}
                onChangeContent={(val) => handleUpdate(val, 'deviceContent')}
              />
            </Accordion>
          </div>
        )
      case refElements.COLUMNS:
        return (
          <Accordion defaultActiveItems={['default']}>
            <ColumnsContent
              label="Default Content"
              subValue="default"
              valueContent={defaultContent}
              onChangeContent={(val) => handleUpdate(val, 'defaultContent')}
            />
            <DevicesColumnsContent
              label="Override content in each device"
              subValue="device"
              valueContent={deviceContent}
              onChangeContent={(val) => handleUpdate(val, 'deviceContent')}
            />
          </Accordion>
        )
      case refElements.DIVIDER:
        return (
          <Wrapper margin={1}>
            <DividerContent
              valueContent={defaultContent}
              valueSettings={defaultSettings}
              handleUpdate={onChange}
              value={value}
            />
          </Wrapper>
        )
      case refElements.CARD:
        return (
          <Accordion defaultActiveItems={['default']} accordionProps={{ isLargePadded: true }}>
            <CardContent
              label="Default Content"
              subValue="default"
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
            <DevicesCardContent
              label="Override content in each device"
              subValue="device"
              value={deviceContent}
              onChange={(val) => handleUpdate(val, 'deviceContent')}
            />
          </Accordion>
        )
      case refElements.CATEGORY_MENUS:
        return (
          <Accordion defaultActiveItems={['default']} accordionProps={{ isLargePadded: true }}>
            <CategoryMenusContent
              label="Default Content"
              subValue="default"
              valueContent={defaultContent}
              onChangeContent={(val) => handleUpdate(val, 'defaultContent')}
            />
            <DevicesCategoryMenusContent
              label="Override content in each device"
              subValue="device"
              valueContent={deviceContent}
              onChangeContent={(val) => handleUpdate(val, 'deviceContent')}
            />
          </Accordion>
        )
      case refElements.IMAGE_CAROUSEL:
        return (
          <Accordion defaultActiveItems={['default']} accordionProps={{ isLargePadded: true }}>
            <ImageCarouselContent
              label="Default Content"
              subValue="default"
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
            <DevicesImageCarouselContent
              label="Override content in each device"
              subValue="device"
              value={deviceContent}
              onChange={(val) => handleUpdate(val, 'deviceContent')}
            />
          </Accordion>
        )
      case refElements.COUNT_DOWN:
        return (
          <Wrapper padding={1}>
            <CountDownContent
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      case refElements.PRODUCT_SLIDER:
        return (
          <Wrapper padding={1}>
            <ProductSliderContent
              value={defaultContent}
              onChange={(val) => handleUpdate(val, 'defaultContent')}
            />
          </Wrapper>
        )
      default:
        return <div>unedited content</div>
    }
  }

  return (
    <div>
      {renderForms()}
    </div>
  )
}

ContentSwitcher.propTypes = {}
ContentSwitcher.defaultProps = {}

export default ContentSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/ContentSwitcher.js